/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { PromptStarterState, PromptStarterSlots } from './PromptStarter.types';

/**
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 */
export const renderPromptStarter_unstable = (state: PromptStarterState): JSXElement => {
  assertSlots<PromptStarterSlots>(state);

  return (
    <state.root>
      <state.icon />
      <state.category>
        {state.category.children} {state.badge && <state.badge />}
      </state.category>
      {state.prompt && <state.prompt />}
    </state.root>
  );
};
